import { Component, HostListener, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSelectChange } from '@angular/material/select';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import * as moment from 'moment';
import * as saveSvgAsPng from 'save-svg-as-png';
import { PrintService } from '../print.service';
import { RouseService } from '../rouse.service';
import { UserService } from '../user.service';
//import { Router } from '@angular/router';
//import * as $ from 'jquery';
import { MatDialog } from '@angular/material/dialog';
import { UserProfileDialogComponent } from '../user/profile/userprofile.component';
import { UpdatePasswordDialogComponent } from '../user/profile/update-password.component';
import { SaveReportDialog } from './save-report-dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationDialogComponent } from '../config/confirmation-dialog/confirmation-dialog.component';
import { ToastrService } from 'ngx-toastr';
import { SendEmailDialog } from './send-email-dialog';
import * as internal from 'assert';
import { Local } from 'protractor/built/driverProviders';
import { first } from 'rxjs/operators';
import { type } from 'os';
import { StepTypes } from '../app.constants';
import { DatePipe } from '@angular/common';
export interface SaveReportDialogData {
  dialogTitle: string;
  dialogMode: string;
  id: number;
  filename: string;
  selectedOption: number;
  newFilename: string;
}

export interface SendEmailDialogData {
  dialogTitle: string;
  selectedOption: number;
  newEmail: string;
  myEmail: string;
}

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  toastRef: any;
  userFullName = '';
  selectedReportId: number = 0;

  /*   This can be refactored*/
  isSavedReportEmpty = true;
  isCostNotNull = true;

  form: FormGroup = new FormGroup({
    matterCode: new FormControl(''),
    clientRef: new FormControl(''),
    country: new FormControl('', Validators.required),
    protectionType: new FormControl(''),
    filingRoute: new FormControl(''),
    technicalField: new FormControl(''),
    filingDate: new FormControl(''),
    countryId: new FormControl(''),
    protectionTypeId: new FormControl(''),
    filingRouteId: new FormControl(''),
    technicalFieldId: new FormControl(''),
  });

  matterCode: string;
  clientRef: string;
  countries: any[] = [];
  protectionTypes: any[] = [];
  filingRoutes: any[] = [];
  technicalFields: any[] = [];
  calculatorData: any[] = [];
  selectedItems: Set<number> = new Set();
  selectedReportData: any;
  stepDurationData: any[] = [];
  estimatedGrantDate: string = '';
  showConfiguration: boolean = true;
  isExpanded: boolean = false;
  singaporeLogoPath = window.location.href.split('?')[0] + "resources/AmicaLaw Logo GBg.png";
  malaysiaLogoPath = window.location.href.split('?')[0] + "resources/HenryGoh Logo.png";
  taiwanLogoPath = window.location.href.split('?')[0] + "resources/Cohorizon Logo.png";
  indiaLogoPath = window.location.href.split('?')[0] + "resources/Lakshmikumaran Logo.png";
  koreaLogoPath = window.location.href.split('?')[0] + "resources/YPLee Logo.png";
  totalCost: string;
  totalProfessional: string;
  subtotal: string;
  showGrid: boolean = false;
  reportName: string = "New";
  totalCostMin: number = 0;
  totalCostMax: number = 0;
  totalProfessionalMin: number = 0;
  totalProfessionalMax: number = 0;
  subtotalMin: number = 0;
  subtotalMax: number = 0;

  timelineImages: string[] = [];
  isGeneratingCharts: boolean = false;
  attachments: { OriginalFileName: string, Base64Content: string }[] = [];

  officialName: string = 'Official Fee (USD)';
  professionalName: string = 'Professional Fee (USD)';
  totalName: string = 'Total Fee (USD)';
  constructor(private rouseService: RouseService,
    private printService: PrintService,
    private userService: UserService,
    public dialog: MatDialog,
    private route: ActivatedRoute,
    private toastr: ToastrService,
    private datePipe: DatePipe,
    private router: Router) {

    this.userFullName = localStorage.getItem('email');
  }


  /*   This can be refactored*/
  async checkifSavedIsEmpty() {
    if (this.calculatorData.length != 0) {
      this.isSavedReportEmpty = false;
    }

  }

  /*   This can be refactored*/
  async checkifNullCost() {
    this.isCostNotNull = false;

    for (let x = 0; x < this.stepDurationData.length; x++) {
      if (this.stepDurationData[x].cost != 0 && this.stepDurationData[x].cost != null && this.stepDurationData[x].cost != undefined) {
        this.isCostNotNull = true;
      }
    }
  }

  async ngOnInit(): Promise<void> {

    this.selectedReportId = 0;
    this.showGrid = true;
    this.route.queryParams
      .subscribe(params => {
        if (params.id) {
          this.selectedReportId = params.id;
        }
      });

    if (this.selectedReportId > 0) {
      this.selectedReportData = await this.rouseService.GetSavedReportDataById(this.userFullName, this.selectedReportId);
      this.reportName = this.selectedReportData.filename;

      if (this.selectedReportData.countryId > 0) {
        this.form.get('country').disable();
      }

      if (!this.showProtectionType()) {
        this.form.get('protectionType').disable();
      }

      if (!this.showFilingRoute()) {
        this.form.get('filingRoute').disable();
      }

      if (!this.showTechnicalField()) {
        this.form.get('technicalField').disable();
      }
    }
    sessionStorage.clear();

    this.showConfiguration = this.userService.roleMatch(['Admin']);

    if (typeof Storage != 'undefined') {

      let sessionMatterCode = sessionStorage.getItem('matterCode');
      if (sessionMatterCode === null) {
        this.matterCode = '';
      }
      else {
        this.matterCode = sessionMatterCode;
      }

      let sessionClientRef = sessionStorage.getItem('clientRef');
      if (sessionClientRef === null) {
        this.clientRef = '';
      }
      else {
        this.clientRef = sessionClientRef;
      }

      let sessionCountries = sessionStorage.getItem('countries');
      if (sessionCountries === null) {
        this.countries = await this.rouseService.getCountries();
      }
      else {
        this.countries = JSON.parse(sessionCountries);
      }
      this.countries = this.countries.sort((a, b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0));

      let sessionCountry = sessionStorage.getItem('country');
      if (this.selectedReportData != null) {
        this.countryId = Number(this.selectedReportData.countryId);
        this.form.controls['country'].setValue(this.countryId);
      }
      else if (sessionCountry === null) {
        this.countryId = 0;
        this.form.controls['country'].setValue('');
      }
      else {
        this.countryId = Number(sessionCountry);
        this.form.controls['country'].setValue(sessionCountry);
      }

      let sessionProtectionTypes = sessionStorage.getItem('protectionTypes');
      if (sessionProtectionTypes === null) {
        this.protectionTypes = await this.rouseService.getProtectionTypes(this.countryId);
      }
      else {
        this.protectionTypes = JSON.parse(sessionProtectionTypes);
      }

      let sessionProtectionType = sessionStorage.getItem('protectionType');
      if (this.selectedReportData != null) {
        this.protectionTypeId = Number(this.selectedReportData.protectionTypeId);
        this.form.controls['protectionType'].setValue(this.protectionTypeId);
      }
      else if (sessionProtectionType === null) {

        this.protectionTypeId = 0;
        this.form.controls['protectionType'].setValue('');
      }
      else {
        this.form.controls['protectionType'].setValue(sessionProtectionType);
      }

      let sessionFilingRoutes = sessionStorage.getItem('filingRoutes');
      if (sessionFilingRoutes === null) {
        this.filingRoutes = await this.rouseService.getFilingRoutes(this.countryId, this.protectionTypeId);
      }
      else {
        this.filingRoutes = JSON.parse(sessionFilingRoutes);
      }

      let sessionFilingRoute = sessionStorage.getItem('filingRoute');
      if (this.selectedReportData != null) {
        this.filingRouteId = Number(this.selectedReportData.filingRouteId);
        this.form.controls['filingRoute'].setValue(this.filingRouteId);
      }
      else if (sessionFilingRoute === null) {
        this.filingRouteId = 0;
        this.form.controls['filingRoute'].setValue('');
      }
      else {
        this.form.controls['filingRoute'].setValue(sessionFilingRoute);
      }

      let sessionTechnicalFields = sessionStorage.getItem('technicalFields');
      if (sessionTechnicalFields === null) {
        this.technicalFields = await this.rouseService.getTechnicalFields(this.countryId, this.protectionTypeId, this.filingRouteId);
      }
      else {
        this.technicalFields = JSON.parse(sessionTechnicalFields);
      }

      let sessionTechnicalField = sessionStorage.getItem('technicalField');
      if (this.selectedReportData != null) {
        this.technicalFieldId = Number(this.selectedReportData.technicalFieldId);
        this.form.controls['technicalField'].setValue(this.technicalFieldId);
      }
      else if (sessionTechnicalField === null) {
        this.technicalFieldId = 0;
        this.form.controls['technicalField'].setValue('');
      }
      else {
        this.form.controls['technicalField'].setValue(sessionTechnicalField);
      }

      let sessionFilingDate = sessionStorage.getItem('filingDate');
      if (this.selectedReportData != null) {
        this.form.controls['filingDate'].setValue(moment(this.selectedReportData.filingDate));
      }
      else if (sessionFilingDate === null) {
        this.form.controls['filingDate'].setValue(moment().startOf('day'));
      }
      else {
        this.form.controls['filingDate'].setValue(moment(sessionFilingDate));
      }

      let sessionEstimatedGrantDate = sessionStorage.getItem('estimatedGrantDate');
      if (sessionEstimatedGrantDate === null) {
      }
      else {
        this.estimatedGrantDate = sessionEstimatedGrantDate;
      }

      let sessionStepDurationData = sessionStorage.getItem('stepDurationData');
      if (sessionStepDurationData === null) {
        this.loadStepDurationData();
      }
      else {
        let stepDurationData = JSON.parse(sessionStepDurationData);
        for (let step of stepDurationData) {
          step.result0 = moment(step.result0);
          step.result1 = moment(step.result1);
        }

        this.stepDurationData = stepDurationData;
      }

      let sessionTimeline = sessionStorage.getItem('timeline');
      if (sessionTimeline === null) {
      }
      else {
        this.timeline = JSON.parse(sessionTimeline);
        let timelineData = this.timeline.data;
        for (let data of timelineData) {
          data[4] = new Date(data[4]);
          data[5] = new Date(data[5]);
        }
      }


      this.calculatorData = await this.rouseService.getSavedReportData(this.userFullName);

      /*   This can be refactored*/
      this.checkifSavedIsEmpty();

      this.getSumCost();
      sessionStorage.clear();
    }
  }


  async loadCountryData(): Promise<void> {
    this.protectionTypeId = 0;
    this.filingRoutes = [];
    this.filingRouteId = 0;
    this.stepDurationData = [];
    this.technicalFieldId = 0;
    this.technicalFields = [];

    this.protectionTypes = await this.rouseService.getProtectionTypes(this.countryId);
    if (this.protectionTypes.length > 0) {
      this.protectionTypeId = this.protectionTypes[0].id;
      this.filingRoutes = await this.rouseService.getFilingRoutes(this.countryId, this.protectionTypeId);
      if (this.filingRoutes.length > 0) {
        this.filingRouteId = this.filingRoutes[0].id;
        this.stepDurationData = await this.loadStepDuration(this.countryId, this.protectionTypeId, this.filingRouteId, this.technicalFieldId);
        this.buildFormControls();
        this.calculateAllStepDurations();
      }
    }
  }

  async loadProtectionTypeData(): Promise<void> {
    this.filingRoutes = await this.rouseService.getFilingRoutes(this.countryId, this.protectionTypeId);
    if (this.filingRoutes.length > 0) {
      this.filingRouteId = this.filingRoutes[0].id;

      this.stepDurationData = await this.loadStepDuration(this.countryId, this.protectionTypeId, this.filingRouteId, this.technicalFieldId);
    }
    else {
      this.filingRouteId = 0;
    }
  }

  async loadFilingRouteData(): Promise<void> {
    this.stepDurationData = await this.loadStepDuration(this.countryId, this.protectionTypeId, this.filingRouteId, this.technicalFieldId);
  }

  async loadStepDuration(countryId: number, protectionTypeId: number, filingRouteId: number, technicalFieldId: number): Promise<any[]> {
    if (countryId !== 0 && protectionTypeId !== 0 && filingRouteId !== 0 && technicalFieldId !== 0) {
      return await this.rouseService.getStepDuration(countryId, protectionTypeId, filingRouteId, technicalFieldId);
    }
    return [];
  }

  countryId: number = 0;
  countryName: string = "";
  protectionTypeId: number = 0;
  protectionTypeName: string = "";
  filingRouteId: number = 0;
  technicalFieldId: number = 0;

  async loadStepDurationData(): Promise<void> {
    if (this.countryId !== 0 && this.protectionTypeId !== 0 && this.filingRouteId !== 0 && this.technicalFieldId !== 0 && (this.selectedReportId === undefined || this.selectedReportId === 0)) {
      this.stepDurationData = await this.rouseService.getStepDuration(this.countryId, this.protectionTypeId, this.filingRouteId, this.technicalFieldId);
      this.buildFormControls();
      this.calculateAllStepDurations();
    }
    else {
      if (this.selectedReportData) {
        var steps = JSON.parse(this.selectedReportData.data);
        this.stepDurationData = steps;
        this.buildFormControls();
        this.calculateAllStepDurations();
      }
    }
  }

  async onCountryChanged(event: MatSelectChange): Promise<void> {

    this.countryId = event.value;
    this.countryName = event.source.triggerValue;

    this.protectionTypes = await this.rouseService.getProtectionTypes(this.countryId);
    this.protectionTypeId = 0;
    this.form.controls['protectionType'].setValue('');

    this.filingRoutes = [];
    this.filingRouteId = 0;

    this.technicalFields = [];
    this.technicalFieldId = 0;
  }

  async onProtectionTypeChanged(event: MatSelectChange): Promise<void> {
    this.protectionTypeId = event.value;
    this.protectionTypeName = event.source.triggerValue;

    this.filingRoutes = await this.rouseService.getFilingRoutes(this.countryId, this.protectionTypeId);
    this.filingRouteId = 0;
    this.form.controls['filingRoute'].setValue('');

  }

  async onFilingRouteChanged(event: MatSelectChange): Promise<void> {
    this.filingRouteId = event.value;
    console.log("Filing Route ID " + this.filingRouteId);
    this.technicalFields = await this.rouseService.getTechnicalFields(this.countryId, this.protectionTypeId, this.filingRouteId);
    this.technicalFieldId = 0;
    this.form.controls['technicalField'].setValue('');
  }

  async onTechnicalFieldChanged(event: MatSelectChange): Promise<void> {
    this.technicalFieldId = event.value;
    console.log("Technical Field ID " + this.technicalFieldId);
    await this.loadStepDurationData();
  }

  onQtyChange(value: any, input: any, index: number): void {
    input.qty = Number(value.srcElement.value) || 0;

    const step = this.stepDurationData[index];
    if (!step) return;

    step.userInput.values.forEach(i => {
      if (i.selected) {
        const qty = Number(i.qty) || 0;

        // Handle professional value
        if (typeof i.professional === "string" && i.professional.startsWith("=")) {
          const fixed = parseFloat(i.professional.slice(1));
          i.totalProfessional = isNaN(fixed) ? 0 : fixed;
        } else {
          i.totalProfessional = qty * (Number(i.professional) || 0);
        }

        // Handle official value
        if (typeof i.official === "string" && i.official.startsWith("=")) {
          const fixed = parseFloat(i.official.slice(1));
          i.totalOfficial = isNaN(fixed) ? 0 : fixed;
        } else {
          i.totalOfficial = qty * (Number(i.official) || 0);
        }
      }
    });

    this.getSumCost();
  }

  preventNegative(event: KeyboardEvent) {
    const input = event.target as HTMLInputElement;
    const currentValue = Number(input.value) || 0;

    if (event.key === '-' || event.key === 'e' || event.key === 'E') {
      event.preventDefault();
    }

    // If ArrowDown is pressed and value is 0 or less, prevent decrement
    if (event.key === 'ArrowDown' && currentValue <= 0) {
      event.preventDefault();
    }
  }

  onWheel(event: WheelEvent) {
    const input = event.target as HTMLInputElement;
    if (input.type === 'number') {
      input.blur(); // Remove focus so the wheel can't change value
    }
  }

  formatUserInput(value: any): string {
    if (value == 0 || value == null || value == undefined) {
      return "";
    } else {
      //return `$ ${value.toFixed(2)}`;
      return this.formatCurrency(value, false);
    }
  }

  hasSelectedInputs(step: any): boolean {
    return step.selected &&
      step.userInput &&
      Array.isArray(step.userInput.values) &&
      step.userInput.values.some(input => input && input.selected);
  }

  getCostOrRange(value: any): string {
    // If value is a string and formatted as a range (e.g., "1-100")
    if (typeof value === "string" && value.includes("-")) {
      const [min, max] = value.split("-").map(Number);
      if (!isNaN(min) && !isNaN(max)) {
        return `${min.toFixed(2)} - ${max.toFixed(2)}`;
      }
    }

    // If it's an object with 'min' and 'max', format as a range: "min - max"
    if (value && typeof value === "object" && value.min !== undefined && value.max !== undefined) {
      const min = value.min;
      const max = value.max;
      return `${min.toFixed(2)} - ${max.toFixed(2)}`;
    }

    // If it's a number, format it as a single value
    if (typeof value === "number" && value !== 0) {
      return value.toFixed(2);
    }

    // If it's a string that can be parsed to a number, format it
    if (value !== "0" && typeof value === "string" && !isNaN(parseFloat(value))) {
      return parseFloat(value).toFixed(2);
    }

    return ""; // Return an empty string for invalid or missing values
  }

  // General method for getting cost or professional fee
  getStepCostOrFee(index: number, key: "cost" | "professional"): string {
    const step = this.stepDurationData[index];
    let value = "";

    const selectedIndex = step.duration.true && step.duration.true.selectedValueIndex;
    const values = step.duration.true && step.duration.true.values;

    if (selectedIndex !== null && selectedIndex !== undefined && values && values[selectedIndex] && values[selectedIndex][key] !== undefined) {
      value = this.getCostOrRange(values[selectedIndex][key]);
    }
    else if (step[key] !== undefined) {
      value = this.getCostOrRange(step[key]);
    }

    // Return formatted value using formatCurrency, or an empty string if no value exists
    if (value.includes("-")) {
      const parts = value.split("-").map(part => part.trim());

      // Ensure we only format two parts: min and max
      const min = parseFloat(parts[0]);
      const max = parseFloat(parts[1]);

      const formattedMin = isNaN(min) ? parts[0] : this.formatCurrency(min, false);
      const formattedMax = isNaN(max) ? parts[1] : this.formatCurrency(max, false);

      return `${formattedMin} - ${formattedMax}`;
    }

    const numericValue = parseFloat(value);

    return !isNaN(numericValue) ? this.formatCurrency(numericValue, false) : "";
  }

  // Usage for cost:
  getDurationCost(index: number): string {
    return this.getStepCostOrFee(index, "cost");
  }

  // Usage for professional fee:
  getProfessionalFee(index: number): string {
    return this.getStepCostOrFee(index, "professional");
  }

  calculateTotal(index: number): string {
    const durationCostString = this.getDurationCost(index);
    const professionalFeeString = this.getProfessionalFee(index);

    let durationCostMin = 0;
    let durationCostMax = 0;
    let professionalFeeMin = 0;
    let professionalFeeMax = 0;

    const cleanValue = (val: string): number =>
      parseFloat(val.replace(/\$|\s|,/g, "")) || 0;

    // Handle duration cost (which could be a range)
    if (durationCostString.includes(" - ")) {
      const [costMin, costMax] = durationCostString.split(" - ").map(cleanValue);
      durationCostMin = costMin;
      durationCostMax = costMax;
    } else {
      durationCostMin = cleanValue(durationCostString);
      durationCostMax = durationCostMin;
    }

    // Handle professional fee (which could be a range)
    if (professionalFeeString.includes(" - ")) {
      const [feeMin, feeMax] = professionalFeeString.split(" - ").map(cleanValue);
      professionalFeeMin = feeMin;
      professionalFeeMax = feeMax;
    } else {
      professionalFeeMin = cleanValue(professionalFeeString);
      professionalFeeMax = professionalFeeMin;
    }

    const totalMin = durationCostMin + professionalFeeMin;
    const totalMax = durationCostMax + professionalFeeMax;

    if (totalMin === 0) return "";

    return totalMin !== totalMax
      ? `${this.formatCurrency(totalMin, false)} - ${this.formatCurrency(totalMax, false)}`
      : this.formatCurrency(totalMin, false);
  }

  getFixedDurationCost(index: number): string {
    const step = this.stepDurationData[index];
    var cost = "";
    if (step.type === StepTypes.FIXED) {
      return step.cost ? "$ " + step.cost.toFixed(2) : ""
    }

    if (step.duration.true.selectedValueIndex > 0) {
      let selectedCost: number = 0;
      if (step.duration.true.values[step.duration.true.selectedValueIndex].cost) {
        selectedCost = parseFloat(step.duration.true.values[step.duration.true.selectedValueIndex].cost);
      }
      cost = selectedCost.toFixed(2).toString();
    }
    else if (step.duration.true.selectedValueIndex == 0) {
      let selectedCost: number = 0;
      if (step.duration.true.values[step.duration.true.selectedValueIndex].cost) {
        selectedCost = parseFloat(step.duration.true.values[step.duration.true.selectedValueIndex].cost);
      }
      else if (step.cost) {
        selectedCost = parseFloat(step.cost);
      }
      cost = selectedCost.toFixed(2).toString();
    }
    else {
      if (step.cost) {
        cost = parseFloat(step.cost).toFixed(2).toString();
      }
    }

    if (cost === "0.00") {
      return "";
    }
    return `$ ${cost}`;

  }
  getGroupProfessional(groupName: string): number {
    let professional: number = 0;

    for (let step of this.stepDurationData.filter(t => t.groupName === groupName && t.selected)) {
      let defaultValue = step.duration[step.selected].values[step.duration[step.selected].selectedValueIndex];
      if (defaultValue.value > 0 && step.selected) {
        if (step.type === StepTypes.FIXED_SELECTION || step.type === StepTypes.TOGGLE_SELECTION) {
          professional += Number.parseFloat(step.duration[step.selected].values[step.duration[step.selected].selectedValueIndex].professional);
        }
        else {
          var fee = Number.parseFloat(step.professional);
          if (fee) {
            professional += fee;
          }
        }
      }
    }

    return professional;

  }
  calculateSubtotal(step: any): string {
    let costMin = step.cost && typeof step.cost === 'object' && step.cost.min !== undefined ? step.cost.min : step.cost || 0;
    let costMax = step.cost && typeof step.cost === 'object' && step.cost.max !== undefined ? step.cost.max : step.cost || 0;

    let professionalMin = step.professional && typeof step.professional === 'object' && step.professional.min !== undefined ? step.professional.min : step.professional || 0;
    let professionalMax = step.professional && typeof step.professional === 'object' && step.professional.max !== undefined ? step.professional.max : step.professional || 0;

    // If either cost or professional is a range, compute the subtotal as a range
    let subtotalMin = costMin + professionalMin;
    let subtotalMax = costMax + professionalMax;

    // If subtotalMin is 0, return an empty string
    if (subtotalMin === 0) {
      return "";
    }

    // If both cost and professional are single values (not ranges), return a single value
    if (costMin === costMax && professionalMin === professionalMax) {
      return `${this.formatCurrency(subtotalMin, false)}`; // return as a single value
    }

    // Otherwise, return the range
    return `${this.formatCurrency(subtotalMin, false)} - ${this.formatCurrency(subtotalMax, false)}`;
  }

  getGroupCost(groupName: string): number {
    let officialFee: number = 0;

    for (let step of this.stepDurationData.filter(t => t.groupName === groupName && t.selected)) {
      let defaultValue = step.duration[step.selected].values[step.duration[step.selected].selectedValueIndex];
      if (defaultValue.value > 0 && step.selected) {
        if (step.type === StepTypes.FIXED_SELECTION || step.type === StepTypes.TOGGLE_SELECTION) {
          officialFee += Number.parseFloat(step.duration[step.selected].values[step.duration[step.selected].selectedValueIndex].cost);
        }
        else {
          var fee = Number.parseFloat(step.cost);
          if (fee) {
            officialFee += fee;
          }
        }
      }
    }

    return officialFee;

  }

  getSumCost() {
    // Reset totals
    this.totalCostMin = 0;
    this.totalCostMax = 0;
    this.totalProfessionalMin = 0;
    this.totalProfessionalMax = 0;

    for (let j = 0; j < this.stepDurationData.length; j++) {
      const step = this.stepDurationData[j];

      if (!step || !step.selected) continue;

      let costMin = 0;
      let costMax = 0;
      let professionalMin = 0;
      let professionalMax = 0;

      const duration = step.duration && step.duration.true;
      const hasDuration = duration && Array.isArray(duration.values);

      let selectedValue = null;

      if (hasDuration && typeof duration.selectedValueIndex === 'number') {
        selectedValue = duration.values[duration.selectedValueIndex];
      }

      // Utility to parse cost
      const parseRange = (val: any): { min: number; max: number } => {
        if (val === null || val === undefined) {
          return { min: 0, max: 0 };
        }

        if (typeof val === 'object' && val.min !== undefined && val.max !== undefined) {
          return {
            min: parseFloat(val.min),
            max: parseFloat(val.max)
          };
        }

        if (typeof val === 'string') {
          const rangeMatch = val.match(/^(\d+(?:\.\d+)?)\s*-\s*(\d+(?:\.\d+)?)$/);
          if (rangeMatch) {
            return {
              min: parseFloat(rangeMatch[1]),
              max: parseFloat(rangeMatch[2])
            };
          } else {
            const num = parseFloat(val);
            return { min: num, max: num };
          }
        }

        const fallback = parseFloat(val);
        return {
          min: isNaN(fallback) ? 0 : fallback,
          max: isNaN(fallback) ? 0 : fallback
        };
      };

      // Get cost
      if (selectedValue && selectedValue.cost !== undefined) {
        const range = parseRange(selectedValue.cost);
        costMin = range.min;
        costMax = range.max;
      } else if (step.cost && step.cost !== undefined) {
        const range = parseRange(step.cost);
        costMin = range.min;
        costMax = range.max;
      }

      // Get professional fee
      if (selectedValue && selectedValue.professional !== undefined) {
        const range = parseRange(selectedValue.professional);
        professionalMin = range.min;
        professionalMax = range.max;
      } else if (step.professional && step.professional !== undefined) {
        const range = parseRange(step.professional);
        professionalMin = range.min;
        professionalMax = range.max;
      }

      this.totalCostMin += costMin;
      this.totalCostMax += costMax;
      this.totalProfessionalMin += professionalMin;
      this.totalProfessionalMax += professionalMax;

      // Add userInput selected values' totals
      if (
        step.userInput &&
        step.userInput.values &&
        Array.isArray(step.userInput.values)
      ) {
        for (let k = 0; k < step.userInput.values.length; k++) {
          const input = step.userInput.values[k];
          if (input && input.selected) {
            const official = Number(input.totalOfficial) || 0;
            const professional = Number(input.totalProfessional) || 0;

            this.totalCostMin += official;
            this.totalCostMax += official;

            this.totalProfessionalMin += professional;
            this.totalProfessionalMax += professional;
          }
        }
      }
    }

    // Final subtotal
    this.subtotalMin = this.totalCostMin + this.totalProfessionalMin;
    this.subtotalMax = this.totalCostMax + this.totalProfessionalMax;

    // Format
    this.totalCost = this.totalCostMin !== this.totalCostMax
      ? `${this.formatCurrency(this.totalCostMin, false)} - ${this.formatCurrency(this.totalCostMax, false)}`
      : this.formatCurrency(this.totalCostMin, false);

    this.totalProfessional = this.totalProfessionalMin !== this.totalProfessionalMax
      ? `${this.formatCurrency(this.totalProfessionalMin, false)} - ${this.formatCurrency(this.totalProfessionalMax, false)}`
      : this.formatCurrency(this.totalProfessionalMin, false);

    this.subtotal = this.subtotalMin !== this.subtotalMax
      ? `${this.formatCurrency(this.subtotalMin, false)} - ${this.formatCurrency(this.subtotalMax, false)}`
      : this.formatCurrency(this.subtotalMin, false);

    // Check null cost edge cases
    this.checkifNullCost();
  }

  formatCurrency(value: any, currencySignShown: boolean = true): string {
    const formatted = parseFloat(value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return currencySignShown ? `$ ${formatted}` : formatted;
  }

  formatCurrencyTimelineChart(value) {
    return `${parseFloat(value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  }


  isNotNormalProcess(type: string): boolean {
    return type !== StepTypes.FIXED;
  }
  isNormalProcess(type: string): boolean {
    return type === StepTypes.FIXED;
  }

  buildFormControls() {
    for (let i in this.stepDurationData) {
      let step = this.stepDurationData[i];
      if ('options' in step) {
        for (let j in step.options) {
          let option = step.options[j];
          if ('selectItems' in option) {
            let formControl: FormControl = new FormControl(i + ',' + j + ',0');
            this.form.addControl('select' + i + '-' + j, formControl);
          }
        }
      }
    }
  }

  showFilingDate(): boolean {
    if (this.selectedReportData) {
      return false;
    }
    else {
      return (this.protectionTypeId !== 0 && this.filingRouteId !== 0 && this.technicalFieldId !== 0 && this.selectedReportData == null);
    }

  }
  showFormButtons(): boolean {
    if (this.selectedReportData) {
      return true;
    }
    else {
      return (this.protectionTypeId !== 0 && this.filingRouteId !== 0 && this.technicalFieldId !== 0 && this.selectedReportData == null);
    }

  }
  showProtectionType(): boolean {
    return this.countryId !== 0 && this.selectedReportData == null;
  }

  showFilingRoute(): boolean {
    return this.showProtectionType() && (this.protectionTypeId !== 0);
  }

  showTechnicalField(): boolean {
    return this.showFilingRoute() && (this.filingRouteId !== 0);
  }

  showStepDurations(): boolean {
    return (this.form.controls['filingDate'].value !== null);
  }

  onFilingDateChange(event: any) {
    this.calculateAllStepDurations();
  }

  getDatePlaceholder() {
    return this.filingRoutes.find(x => x.id == this.form.controls['filingRoute'].value) != undefined &&
      this.filingRoutes.find(x => x.id == this.form.controls['filingRoute'].value).name == "PCT National Application" ? "National Phase Entry Date" : "Filing Date";
  }

  onSlideToggleChange(ob: MatSlideToggleChange) {
    const stepIndex = ob.source.id;
    const step = this.stepDurationData[stepIndex];
    step.selected = !step.selected;

    if ((step.type === StepTypes.TOGGLE || step.type === StepTypes.TOGGLE_SELECTION) && !step.selected) {
      if (step.enableStepIndex > -1) {
        this.stepDurationData[stepIndex].selected = false;
      }
    }

    // Handle recursive disabling/enabling of child and grandchild steps
    this.updateDependentSteps(+stepIndex, step.selected);

    this.getSumCost();
    this.calculateAllStepDurations();
  }

  updateDependentSteps(parentIndex: number, isParentSelected: boolean) {
    this.stepDurationData.forEach((step, index) => {
      if (step.enabledBy === parentIndex.toString()) {
        step.disabled = !isParentSelected;

        if (!isParentSelected) {
          step.selected = false;
        }

        // Recursively handle further descendants
        this.updateDependentSteps(index, isParentSelected);
      }
    });
  }


  onSlideToggleChangeForSelectItem(ob: MatSlideToggleChange, step: any, j: number) {

  }

  // Default return value: false
  isDisabled(step: any) {
    if (step.type === StepTypes.FIXED_SELECTION) {
      return false;
    }
    if (step.enabledBy === "-1") {
      return false;
    }

    let controlStep = this.stepDurationData[step.enabledBy];
    return !controlStep.selected;
  }

  // Default return value: true
  getEnabledByOptionIndex(ops: any, op: any): boolean {
    let selected: boolean = true;
    if (typeof op.enabledByOptionIndex !== 'undefined') {
      let refOp = ops[op.enabledByOptionIndex];
      selected = refOp.selected;
    }
    return selected;
  }

  showSelectItem(ob: any): boolean {
    return ('selectItems' in ob);
  }

  calculateAllStepDurations() {
    if (this.form.controls['protectionType'].value === "" || this.form.controls['filingRoute'].value === "") {
      return;
    }

    setTimeout(() => {
      document.querySelectorAll('#timelineChart text').forEach(el => {
        if (el.textContent === '.' || el.textContent.trim() === '') {
          el.textContent = ''; // Hide the undefined text
        }
      });
    }, 100);

    let groupMinMaxDates = [];
    const filingDate = moment(this.form.controls['filingDate'].value);
    let result0 = filingDate;
    let groupDateStart;
    let lastUngroupedEndDate = null;
    let lastGroupedEndDate = null;

    for (let step of this.stepDurationData) {
      let result0Locked = false;

      // Check if step has a valid 'follows' field
      if (step.follows !== undefined && step.follows !== null && step.follows !== -1) {
        const followedStep = this.stepDurationData[step.follows];
        if (followedStep && followedStep.result1 && followedStep.selected) {
          step.result0 = moment(followedStep.result1);
          result0Locked = true;
        }
      }
      if (!result0Locked) {
        if (step.selected && step.groupName === undefined) {
          result0 = this.stepDurationData
            .slice(0, this.stepDurationData.indexOf(step))
            .filter(s => s.selected && s.result1)
            .reduce((maxDate, s) => moment.max(maxDate, s.result1), filingDate);

          lastUngroupedEndDate = moment(result0).clone();
          step.result0 = moment(result0);
        }
        else if (step.groupName) {
          result0 = this.stepDurationData
            .slice(0, this.stepDurationData.indexOf(step))
            .filter(s => s.result1)
            .reduce((maxDate, s) => moment.max(maxDate, s.result1), filingDate);

          if (!lastGroupedEndDate) {
            lastGroupedEndDate = moment(result0).clone();
          }

          step.result0 = moment(result0);
        }
      }

      if (!result0Locked) {
        step.result0 = moment(result0);
      }

      let duration = step.duration[step.selected].values[step.duration[step.selected].selectedValueIndex];
      if (result0Locked) {
        step.result1 = moment(step.result0).add(duration.value, duration.unit);
      } else {
        step.result1 = moment(result0).add(duration.value, duration.unit);
      }

      if (step.groupName && step.selected) {
        if (!groupDateStart) {
          if (step.overlapStep) {
            groupDateStart = filingDate;
            step.result0 = filingDate;
            step.result1 = groupDateStart.clone().add(duration.value, duration.unit);
            if (lastGroupedEndDate) {
              step.result0 = moment(lastGroupedEndDate);
              step.result1 = lastGroupedEndDate.clone().add(duration.value, duration.unit);
            }
          }
          else {
            groupDateStart = moment(step.result0);
            step.result1 = groupDateStart.clone().add(duration.value, duration.unit);
          }

        } else {
          const minDate = groupMinMaxDates.find(t => t.groupName === step.groupName);

          let startDate;
          if (minDate) {
            startDate = moment(minDate.start);
            if (!step.overlapStep) {
              startDate = moment(result0);
            }
          } else if (lastUngroupedEndDate) {
            startDate = moment(lastUngroupedEndDate); // Use last ungrouped step's end date if minDate is undefined/null
          } else {
            startDate = filingDate.clone(); // Fallback to filing date if no other options exist
          }

          step.result0 = startDate.clone();
          step.result1 = startDate.clone().add(duration.value, duration.unit);
        }

        groupMinMaxDates.push({
          name: step.name,
          groupName: step.groupName,
          start: step.result0,
          end: step.result1,
          type: step.type,
          overlapStep: step.overlapStep === undefined ? false : step.overlapStep
        });

        // Update result0 to max end date of group
        const updatedMaxDate = groupMinMaxDates.reduce(
          (max, item) => (moment(item.end).isAfter(max) ? moment(item.end) : max),
          moment(groupMinMaxDates[0].end)
        );
        result0 = moment(updatedMaxDate);
      } else {
        result0 = moment(step.result1); // For non-grouped rows, just update result0
        if (!step.groupName) {
          lastUngroupedEndDate = moment(step.result1);
        } else {
          lastGroupedEndDate = moment(step.result1);
        }
      }

    }

    let date = result0.format('D MMMM YYYY');
    this.estimatedGrantDate = (date === 'Invalid date') ? "–" : date;

    this.timeline.data = [];
    this.timeline.feeData = [];
    this.timeline.columnNames = [];

    this.timeline.columnNames.push([{ type: 'string', id: 'Step' }]);
    this.timeline.columnNames.push({ type: 'string', id: 'Period' });
    this.timeline.columnNames.push({ type: 'string', role: 'tooltip' });
    this.timeline.columnNames.push({ type: 'string', role: 'style' });
    this.timeline.columnNames.push({ type: 'date', id: 'Start' });
    this.timeline.columnNames.push({ type: 'date', id: 'End' });

    let num = 5;
    result0 = moment(this.form.controls['filingDate'].value);

    let groupFees = [];
    let index = 0;
    for (let step of this.stepDurationData) {
      let defaultValue = step.duration[step.selected].values[step.duration[step.selected].selectedValueIndex];
      if (defaultValue.value > 0 && step.selected) {
        let result1 = moment(result0);

        let addName = '';

        if (step.type === StepTypes.TOGGLE_SELECTION || step.type === StepTypes.FIXED_SELECTION) {
          addName = ' ' + step.duration[step.selected].valueNames[step.duration[step.selected].selectedValueIndex];
        }

        if (step.groupName) {
          const minDate = groupMinMaxDates.find(t => t.groupName === step.groupName && t.name === step.name);

          step.result0 = minDate.start;
          step.result1 = minDate.end;
        } else {
          // step.result0 = result0;
          // step.result1 = result1;
        }

        let officialFeeMin = 0, officialFeeMax = 0;
        let professionalFeeMin = 0, professionalFeeMax = 0;

        // Handle cost
        if (step.cost) {
          if (typeof step.cost === 'object' && step.cost.min !== undefined && step.cost.max !== undefined) {
            officialFeeMin = parseFloat(step.cost.min);
            officialFeeMax = parseFloat(step.cost.max);
          }
          else if (typeof step.cost === 'string') {
            const rangeMatch = step.cost.match(/^(\\d+(?:\.\d+)?)\s*-\s*(\d+(?:\.\d+)?)$/);
            if (rangeMatch) {
              officialFeeMin = parseFloat(rangeMatch[1]);
              officialFeeMax = parseFloat(rangeMatch[2]);
            } else {
              officialFeeMin = officialFeeMax = parseFloat(step.cost);
            }
          }
          else {
            officialFeeMin = officialFeeMax = parseFloat(step.cost);
          }
        }


        // Handle professional fee
        if (step.professional) {
          if (typeof step.professional === 'object' && step.professional.min !== undefined && step.professional.max !== undefined) {
            professionalFeeMin = parseFloat(step.professional.min);
            professionalFeeMax = parseFloat(step.professional.max);
          }
          else if (typeof step.professional === 'string') {
            const rangeMatch = step.professional.match(/^(\d+(?:\.\d+)?)\s*-\s*(\d+(?:\.\d+)?)$/);
            if (rangeMatch) {
              professionalFeeMin = parseFloat(rangeMatch[1]);
              professionalFeeMax = parseFloat(rangeMatch[2]);
            } else {
              professionalFeeMin = professionalFeeMax = parseFloat(step.professional);
            }
          }
          else {
            professionalFeeMin = professionalFeeMax = parseFloat(step.professional);
          }
        }


        // Calculate total fees
        let totalFeeMin = officialFeeMin + professionalFeeMin;
        let totalFeeMax = officialFeeMax + professionalFeeMax;

        let totalFee = totalFeeMin === totalFeeMax
          ? totalFeeMin.toFixed(2)
          : `${totalFeeMin.toFixed(2)} - ${totalFeeMax.toFixed(2)}`;

        if (step.type == StepTypes.TOGGLE_SELECTION || step.type == StepTypes.FIXED_SELECTION) {
          let defaultOfficialFeeMin = 0, defaultOfficialFeeMax = 0;
          let defaultProfessionalFeeMin = 0, defaultProfessionalFeeMax = 0;

          if (defaultValue.cost) {
            // If it's an object with min and max defined
            if (typeof defaultValue.cost === 'object' && defaultValue.cost.min !== undefined && defaultValue.cost.max !== undefined) {
              defaultOfficialFeeMin = parseFloat(defaultValue.cost.min);
              defaultOfficialFeeMax = parseFloat(defaultValue.cost.max);
            }
            else if (typeof defaultValue.cost === 'string') {
              const rangeMatch = defaultValue.cost.match(/^(\d+(?:\.\d+)?)\s*-\s*(\d+(?:\.\d+)?)$/);
              if (rangeMatch) {
                defaultOfficialFeeMin = parseFloat(rangeMatch[1]);
                defaultOfficialFeeMax = parseFloat(rangeMatch[2]);
              } else {
                defaultOfficialFeeMin = defaultOfficialFeeMax = parseFloat(defaultValue.cost);
              }
            }
            else {
              defaultOfficialFeeMin = defaultOfficialFeeMax = parseFloat(defaultValue.cost);
            }
          }

          if (defaultValue.professional) {
            if (typeof defaultValue.professional === 'object' && defaultValue.professional.min !== undefined && defaultValue.professional.max !== undefined) {
              defaultProfessionalFeeMin = parseFloat(defaultValue.professional.min);
              defaultProfessionalFeeMax = parseFloat(defaultValue.professional.max);
            } else if (typeof defaultValue.professional == 'string') {
              const rangeMatch = defaultValue.professional.match(/^(\d+(?:\.\d+)?)\s*-\s*(\d+(?:\.\d+)?)$/);
              if (rangeMatch) {
                defaultProfessionalFeeMin = parseFloat(rangeMatch[1]);
                defaultProfessionalFeeMax = parseFloat(rangeMatch[2]);
              }
              else {
                defaultProfessionalFeeMin = defaultProfessionalFeeMax = parseFloat(defaultValue.professional);
              }
            } else {
              defaultProfessionalFeeMin = defaultProfessionalFeeMax = parseFloat(defaultValue.professional);
            }
          }

          officialFeeMin = defaultOfficialFeeMin;
          officialFeeMax = defaultOfficialFeeMax;
          professionalFeeMin = defaultProfessionalFeeMin;
          professionalFeeMax = defaultProfessionalFeeMax;

          totalFeeMin = officialFeeMin + professionalFeeMin;
          totalFeeMax = officialFeeMax + professionalFeeMax;

          totalFee = totalFeeMin === totalFeeMax
            ? this.formatCurrencyTimelineChart(totalFeeMin)
            : `${this.formatCurrencyTimelineChart(totalFeeMin)} - ${this.formatCurrencyTimelineChart(totalFeeMax)}`;
        }

        let colColor = '#00c04b';
        let timeColor = 'green';

        if (step.type === StepTypes.FIXED || step.type === StepTypes.FIXED_SELECTION) {
          colColor = '#00c04b';
        } else if (step.type === StepTypes.TOGGLE || step.type === StepTypes.TOGGLE_SELECTION) {
          colColor = '#FFA500'; //Orange
          timeColor = '#FF4D00'; //Red Orange
        }

        this.timeline.data.push([
          step.name + addName,
          step.result0.format('D MMMM YYYY') + " - " + step.result1.format('D MMMM YYYY'),
          null,
          'color: ' + timeColor,
          step.result0.toDate(),
          step.result1.toDate()
        ]);

        result1.add(defaultValue.value, defaultValue.unit);

        this.timeline.feeData.push([
          this.officialName,
          officialFeeMin === officialFeeMax
            ? this.formatCurrencyTimelineChart(officialFeeMin)
            : `${this.formatCurrencyTimelineChart(officialFeeMin)} - ${this.formatCurrencyTimelineChart(officialFeeMax)}`,
          colColor,
          step.result0.toDate(),
          step.result1.toDate(),
          step.name
        ]);

        this.timeline.feeData.push([
          this.professionalName,
          professionalFeeMin === professionalFeeMax
            ? this.formatCurrencyTimelineChart(professionalFeeMin)
            : `${this.formatCurrencyTimelineChart(professionalFeeMin)} - ${this.formatCurrencyTimelineChart(professionalFeeMax)}`,
          colColor,
          step.result0.toDate(),
          step.result1.toDate(),
          step.name
        ]);
        this.timeline.feeData.push([
          this.totalName,
          totalFee,
          colColor,
          step.result0.toDate(),
          step.result1.toDate(),
          step.name
        ]);

        num++;
        result0 = moment(result1);
      }
      index++;
    }

    setTimeout(() => {
      document.querySelectorAll('#timelineChart text').forEach(el => {
        if (el.textContent === '.' || el.textContent.trim() === '') {
          el.textContent = ''; // Hide the undefined text
        }
      });
    }, 0);

    //this.timeline.data.push(['.', '', '', '', '', '']);

    const lastValidStep = this.stepDurationData
      .filter(step => step.selected && step.result1)
      .slice(-1)[0]; // Get the last valid step

    let lastValidDate = null; // Initialize it as null

    if (lastValidStep && lastValidStep.result1) {
      lastValidDate = lastValidStep.result1.toDate(); // Access the date directly
    }

    if (lastValidDate) {
      this.timeline.data.push([
        '.',  // Unique label for targeting later
        '',                   // Period
        null,                 // Tooltip
        null,                 // Style
        lastValidDate,        // Start
        lastValidDate         // End
      ]);
    }

    for (let step of this.timeline.feeData) {
      this.timeline.data.push([step[0], step[1], `<div style='padding: 10px;display: inline-block !important;max-width: none !important;white-space: nowrap !important;'> ${step[5]}: <b>${step[1]}</b> </div>`, 'color: ' + step[2], step[3], step[4]]);
    }


    let chartHeight = (num * 50 < 50) ? 50 : num * 50;
    this.timeline.options.height = chartHeight;

    this.refresh();
  }

  getMinDate(): Date {
    return new Date(Math.min(...this.timeline.feeData.map(date => date[3])));
  }

  getMaxDate(): Date {
    return new Date(Math.max(...this.timeline.feeData.map(date => date[4])));
  }
  getToggleColor(step: any) {
    if (step.type === StepTypes.FIXED || step.type === StepTypes.FIXED_SELECTION) {
      return 'green';
    }
    else if (step.type === StepTypes.TOGGLE || step.type === StepTypes.TOGGLE_SELECTION) {
      return 'yellow';
    }
  }

  reapplyBorders() {
    const rects = document.querySelectorAll('#timeline-container svg rect');
    rects.forEach((rect: SVGRectElement) => {
      rect.style.stroke = '#000';        // Border color
      rect.style.strokeWidth = '2px';    // Border thickness
    });
  }

  onChartReady(chartWrapper: any) {
    const chart = chartWrapper.chart;
    this.addBorders(chart);
    

    // Change text color after the chart is fully rendered
    setTimeout(() => {
      const textElements = document.querySelectorAll('#timelineChart text');

      textElements.forEach((textElement: any) => {
        const label = textElement.textContent.trim();

        // Check if the label is one of the fee names
        if (label === this.officialName || label === this.professionalName || label === this.totalName) {
          textElement.setAttribute('fill', 'blue');  // Change text color to blue
        }
        if (label === '.') {
          textElement.setAttribute('visibility', 'hidden');
        }
      });
      this.hideBlankDividerRow();
    }, 100);  // Ensure this is done after the chart is fully rendered
  }

  //// Reapply borders on hover to prevent reset
  //@HostListener('mouseover')
  //@HostListener('mouseout')
  //onHover() {
  //  this.reapplyBorders();
  //}

  addBorders(chart: any) {
    const rectangles = chart.container.getElementsByTagName('rect');
    for (let i = 0; i < rectangles.length; i++) {
      const rect = rectangles[i];
      rect.style.stroke = '#000';
      rect.style.strokeWidth = '2px';
    }
  }

  hideBlankDividerRow(): void {
    setTimeout(() => {
      // Query the #timelineChart element directly
      const container = document.querySelector('#timelineChart svg');

      if (container) {
        const gElements = container.querySelectorAll('g');

        if (gElements.length >= 4) {
          const targetGroup = gElements[3]; // This group contains the rows and rects
          const rects = Array.from(targetGroup.querySelectorAll('rect'));

          // Get all text labels (from the whole chart)
          const textElements = Array.from(document.querySelectorAll('#timelineChart text'));

          // Extract and trim text content
          const rowLabels = textElements.map(el => el.textContent ? el.textContent.trim() : '');

          // Find the index of the 'BLANK_DIVIDER_ROW'
          const blankIndex = rowLabels.findIndex(label => label === '' || label === '.');

          if (blankIndex !== -1) {
            // Style the rect corresponding to that index
            const targetRect = rects[blankIndex];
            if (targetRect) {
              targetRect.style.visibility = 'hidden';
              targetRect.style.fillOpacity = '0'; // Optional: visually hide
            }
          }
        }
      }
    }, 100);
  }

  refresh() {
    this.setSessionVariables();
    this.getSumCost();

    let sessionTimeline = sessionStorage.getItem('timeline');
    if (sessionTimeline === null) {
    }
    else {
      this.timeline = JSON.parse(sessionTimeline);
      let timelineData = this.timeline.data;
      for (let data of timelineData) {
        data[4] = new Date(data[4]);
        data[5] = new Date(data[5]);
      }
    }

  }

  setSessionVariables() {
    sessionStorage.setItem('matterCode', this.form.controls['matterCode'].value);
    sessionStorage.setItem('clientRef', this.form.controls['clientRef'].value);
    sessionStorage.setItem('countries', JSON.stringify(this.countries));
    sessionStorage.setItem('country', this.form.controls['country'].value);
    sessionStorage.setItem('protectionTypes', JSON.stringify(this.protectionTypes));
    sessionStorage.setItem('protectionType', this.form.controls['protectionType'].value);
    sessionStorage.setItem('filingRoutes', JSON.stringify(this.filingRoutes));
    sessionStorage.setItem('filingRoute', this.form.controls['filingRoute'].value);
    sessionStorage.setItem('technicalFields', JSON.stringify(this.technicalFields));
    sessionStorage.setItem('technicalField', this.form.controls['technicalField'].value);
    sessionStorage.setItem('filingDate', this.form.controls['filingDate'].value.format());
    sessionStorage.setItem('stepDurationData', JSON.stringify(this.stepDurationData));
    sessionStorage.setItem('estimatedGrantDate', this.estimatedGrantDate);
    sessionStorage.setItem('timeline', JSON.stringify(this.timeline));
    //sessionStorage.setItem('gantt', JSON.stringify(this.ganttChart));
  }

  errorMessage: any = {};
  public hasError(controlName: string): boolean {
    let errors = this.form.controls[controlName].errors;
    if (errors !== null) {
      if (errors['matDatepickerParse']) {
        this.errorMessage[controlName] = 'Invalid date input';
        return true;
      }
      else if (errors['required']) {
        this.errorMessage[controlName] = 'The field is required';
        return true;
      }
    }
    return false;
  }

  onSelectChanged(ev: MatSelectChange, index: any) {

    //let cost = this.stepDurationData[index].duration.true.values[ev.value].cost;
    this.getSumCost();

    this.calculateAllStepDurations();
  }

  showDurationInfo(step: any): boolean {
    return step.selected;
  }

  showSingaporeContent(): boolean {
    let form = JSON.parse(JSON.stringify(this.form.value));
    const country = this.countries.find(x => x.id == form.country);
    form.country = (typeof country !== 'undefined') ? country.name : '';
    return form.country == 'Singapore';
  }

  getCountrySpecificContent(): string {
    let form = JSON.parse(JSON.stringify(this.form.value));
    const country = this.countries.find(x => x.id == form.country);
    form.country = (typeof country !== 'undefined') ? country.name : '';
    const protectionType = this.protectionTypes.find(x => x.id == form.protectionType);
    form.protectionType = (typeof protectionType !== 'undefined') ? protectionType.name : '';
    const filingRoute = this.filingRoutes.find(x => x.id == form.filingRoute);
    form.filingRoute = (typeof filingRoute !== 'undefined') ? filingRoute.name : '';
    const technicalField = this.technicalFields.find(x => x.id == form.technicalField);
    form.technicalField = (typeof technicalField !== 'undefined') ? technicalField.name : '';

    switch (form.country) {
      case 'Singapore':
        let singaporeMessage = `<ul><li>Publication of the application is not required for the applicant to request for examination in Singapore.</li><li>Publication of the full application occurs automatically 18 months from the priority date and the applicant can request for early publication if desired.</li></ul>`;
        return singaporeMessage;

      case 'Philippines':
        if (form.protectionType === 'Patent' && form.filingRoute === 'PCT National Application') {
          return `<ul><li>The publication in WIPO is considered as the Publication for Opposition.</li></ul>`;
        }
        if (form.protectionType === 'Utility Model' && form.filingRoute === 'PCT National Application') {
          return `<ul><li>The publication in WIPO is considered as the Publication of Utility Model Application.</li></ul>`;
        }
        break;

      case 'Malaysia':
        let malaysiaMessage = `<ul><li>All quoted professional fees are exclusive of 8% SST.</li>`;
        if (form.protectionType === 'Patent') {
          malaysiaMessage += `<li>*At the substantive examination stage, conforming of patent/claims and PPH programmes can only be made/selected if filing substantive examination via ‘normal examination’ is requested.</li>`;
        }
        malaysiaMessage += `</ul>`;
        return malaysiaMessage;

      case 'India':
        if (form.protectionType === 'Patent') {
          return `<ul><li>The application will be published after 18 months from the filing date or the earliest priority date, whichever is earlier.</li><li>The application eligible to expedited examination shall meet the requirements outlined in Rule 24C of the Patent Rules, 2003.</li></ul>`;
        }
        break;

      case 'Taiwan':
        if (form.protectionType === 'Patent') {
          return `<ul><li>The application will be published automatically in the Patent Gazette after 18 months from the filing date or the earliest priority date.</li></ul>`;
        }
        break;

      case 'Korea':
        let koreaMessage = `<ul><li>All quoted professional fees are exclusive of 10% VAT.</li>`;
        if (form.protectionType === 'Patent') {
          koreaMessage += `<li>National/Conventional: Publication of application is after 18 months from the first priority date or from the application date if no priority is claimed.</li><li>PCT National Application: Publication of application is after 18 months from the first priority date or after 2-3 months from the national application phase entry, whichever is later.</li>`;
        } else if (form.protectionType === 'Utility Model') {
          koreaMessage += `<li>National/Conventional: Publication of application is after 18 months from the first priority date or from the application date if no priority is claimed.</li><li>PCT National Application: Publication of application is after 18 months from the first priority date or after 2-3 months from the national application phase entry, whichever is later.</li>`;
        }
        koreaMessage += `</ul>`;
        return koreaMessage;

      default:
        return '';
    }

    return '';
  }


  getCountryLogoMessage(): string {
    let form = JSON.parse(JSON.stringify(this.form.value));
    const country = this.countries.find(x => x.id == form.country);
    form.country = (typeof country !== 'undefined') ? country.name : '';

    switch (form.country) {
      case 'Singapore':
        return `Data have been graciously provided by AMICA LAW LLC.`;
      case 'Malaysia':
        return `Data has been graciously provided by Henry Goh & Co Sdn Bhd.`;
      case 'India':
        return `Data has been graciously provided by Lakshmikumaran Sridharan attorneys.`;
      case 'Taiwan':
        return `Data has been graciously provided by Cohorizon Intellectual Property Ltd.`;
      case 'Korea':
        return `Data has been graciously provided by Y.P. Lee, Mock & Partners.`;
      default:
        return '';
    }
  }

  getCountryLogoHref(): string {
    let form = JSON.parse(JSON.stringify(this.form.value));
    const country = this.countries.find(x => x.id == form.country);
    form.country = (typeof country !== 'undefined') ? country.name : '';

    switch (form.country) {
      case 'Singapore':
        return `https://www.amicalaw.com/`;
      case 'Malaysia':
        return `https://www.henrygoh.com/`;
      case 'India':
        return `https://www.lakshmisri.com/`;
      case 'Taiwan':
        return `https://www.cohorizon.com/`;
      case 'Korea':
        return `https://www.leemock.com/`;
      default:
        return `#`; // Default or placeholder URL
    }
  }

  getCountryLogoPath(): string {
    let form = JSON.parse(JSON.stringify(this.form.value));
    const country = this.countries.find(x => x.id == form.country);
    form.country = (typeof country !== 'undefined') ? country.name : '';

    switch (form.country) {
      case 'Singapore':
        return this.singaporeLogoPath;
      case 'Philippines':
        return '';
      case 'Malaysia':
        return this.malaysiaLogoPath;
      case 'India':
        return this.indiaLogoPath;
      case 'Taiwan':
        return this.taiwanLogoPath;
      case 'Korea':
        return this.koreaLogoPath;
      default:
        return '';
    }
  }

  async getTimelineImage(): Promise<string> {
    let timelineImage: string = '';

    let elem = document.getElementById('timelineChart');

    let svgElement = elem.getElementsByTagName("svg")[0];
    let svgElement2 = elem.getElementsByTagName("svg")[1];

    let svg = svgElement2 ? svgElement2 : svgElement;

    await saveSvgAsPng.svgAsPngUri(svg).then(uri => {
      timelineImage = uri;
    });

    return timelineImage;
  }

  toDataURL = url => fetch(url)
    .then(response => response.blob())
    .then(blob => new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.onloadend = () => resolve(reader.result)
      reader.onerror = reject
      reader.readAsDataURL(blob)
    }));

  async print(): Promise<void> {
    this.setSessionVariables();
    let form = JSON.parse(JSON.stringify(this.form.value));
    form.matterCode = (form.matterCode === "") ? "-" : form.matterCode;
    form.clientRef = (form.clientRef === "") ? "-" : form.clientRef;
    const country = this.countries.find(x => x.id == form.country);
    form.country = (typeof country !== 'undefined') ? country.name : '';
    const protectionType = this.protectionTypes.find(x => x.id == form.protectionType);
    form.protectionType = (typeof protectionType !== 'undefined') ? protectionType.name : '';
    const filingRoute = this.filingRoutes.find(x => x.id == form.filingRoute);
    form.filingRoute = (typeof filingRoute !== 'undefined') ? filingRoute.name : '';
    const technicalField = this.technicalFields.find(x => x.id == form.technicalField);
    form.technicalField = (typeof technicalField !== 'undefined') ? technicalField.name : '';
    form.filingDate = this.form.value.filingDate.format('D MMMM YYYY');
    form.estimatedGrantDate = this.estimatedGrantDate;
    //form.showTechnicalField = this.showTechnicalField();

    //let timelineData: any[] = [];
    let steps: any[] = [];
    //for (let data of this.timeline.data) {
    //  //timelineData.push([data[0], data[1], data[2], data[3]]);
    //  let val = {
    //    name: data[0],
    //    fromDate: moment(data[2]).format('D MMMM YYYY'),
    //    toDate: moment(data[3]).format('D MMMM YYYY')
    //  };
    //  steps.push(val);
    //}
    for (let data of this.stepDurationData) {
      if (data.selected == true) {
        let val = {
          name: data.name,
          fromDate: moment(data.result0._i).format('D MMMM YYYY'),
          toDate: moment(data.result1._i).format('D MMMM YYYY'),
          isNotNormalProcess: data.type !== StepTypes.FIXED,
          cost: data.cost
        };
        steps.push(val);
      }
    }

    var timelineImage = await this.getTimelineImage();

    form['timelineImage'] = timelineImage;
    form['steps'] = steps;

    if (this.showSingaporeContent()) {
      this.toDataURL(this.singaporeLogoPath)
        .then(dataUrl => {
          form['singaporeLogo'] = dataUrl;
          this.printService.printDocument('ppc', btoa(JSON.stringify(form)));
        });
    }
    else {
      this.printService.printDocument('ppc', btoa(JSON.stringify(form)));
    }
  }

  //This onSend function sends the current report and selected saved report/s to an email 1
  //async onSend() {

  //  const dialogRef = this.dialog.open(SendEmailDialog, {
  //    width: '450px',
  //    data: {
  //      dialogTitle: 'Send Report via email',
  //      selectedOption: '1',
  //      newEmail: '',
  //      myEmail: this.userFullName
  //    }
  //  });

  //  dialogRef.afterClosed().subscribe(async result => {
  //    if (result.selectedOption > 0) {
  //      this.toastRef = this.toastr.info("Sending Email...", "Processing", { disableTimeOut: true });

  //      this.setSessionVariables();
  //      let form = JSON.parse(JSON.stringify(this.form.value));
  //      form.matterCode = (form.matterCode === "") ? "-" : form.matterCode;
  //      form.clientRef = (form.clientRef === "") ? "-" : form.clientRef;

  //      const country = this.countries.find(x => x.id == form.country);
  //      form.countryId = form.country;
  //      form.country = (typeof country !== 'undefined') ? country.name : '';

  //      const protectionType = this.protectionTypes.find(x => x.id == form.protectionType);
  //      form.protectionTypeId = form.protectionType;
  //      form.protectionType = (typeof protectionType !== 'undefined') ? protectionType.name : '';

  //      const filingRoute = this.filingRoutes.find(x => x.id == form.filingRoute);
  //      form.filingRouteId = form.filingRoute;
  //      form.filingRoute = (typeof filingRoute !== 'undefined') ? filingRoute.name : '';

  //      const technicalField = this.technicalFields.find(x => x.id == form.technicalField);
  //      form.technicalFieldId = form.technicalField;
  //      form.technicalField = (typeof technicalField !== 'undefined') ? technicalField.name : '';

  //      form.filingDate = this.form.value.filingDate.format('D MMMM YYYY');
  //      form.estimatedGrantDate = this.estimatedGrantDate;

  //      let steps: any[] = [];

  //      for (let data of this.stepDurationData) {
  //        if (data.selected == true) {
  //          var defaultValue = data.duration[data.selected].values[data.duration[data.selected].selectedValueIndex];

  //          // Handle official and professional fees
  //          let officialFeeMin = 0, officialFeeMax = 0;
  //          let professionalFeeMin = 0, professionalFeeMax = 0;

  //          if (data.cost) {
  //            if (typeof data.cost === 'object' && data.cost.min !== undefined && data.cost.max !== undefined) {
  //              officialFeeMin = parseFloat(data.cost.min);
  //              officialFeeMax = parseFloat(data.cost.max);
  //            } else if ((typeof data.cost === 'string' && data.cost.includes('-')) || (typeof data.cost === 'number' && data.cost.toString().includes('-'))) {
  //              const rangeMatch = data.cost.match(/^(\d+(?:\.\d+)?)\s*-\s*(\d+(?:\.\d+)?)$/);
  //              if (rangeMatch) {
  //                officialFeeMin = parseFloat(rangeMatch[1]);
  //                officialFeeMax = parseFloat(rangeMatch[2]);
  //              }
  //            } else {
  //              officialFeeMin = officialFeeMax = parseFloat(data.cost);
  //            }
  //          }

  //          if (data.professional) {
  //            if (typeof data.professional === 'object' && data.professional.min !== undefined && data.professional.max !== undefined) {
  //              professionalFeeMin = parseFloat(data.professional.min);
  //              professionalFeeMax = parseFloat(data.professional.max);
  //            } else if ((typeof data.professional === 'string' && data.professional.includes('-')) || (typeof data.professional === 'number' && data.professional.toString().includes('-'))) {
  //              const rangeMatch = data.professional.match(/^(\d+(?:\.\d+)?)\s*-\s*(\d+(?:\.\d+)?)$/);
  //              if (rangeMatch) {
  //                professionalFeeMin = parseFloat(rangeMatch[1]);
  //                professionalFeeMax = parseFloat(rangeMatch[2]);
  //              }
  //            } else {
  //              professionalFeeMin = professionalFeeMax = parseFloat(data.professional);
  //            }
  //          }

  //          // Adjust for TOGGLE_SELECTION or FIXED_SELECTION
  //          if (data.type == StepTypes.TOGGLE_SELECTION || data.type == StepTypes.FIXED_SELECTION) {
  //            if (defaultValue.cost) {
  //              if (typeof defaultValue.cost === 'object' && defaultValue.cost.min !== undefined && defaultValue.cost.max !== undefined) {
  //                officialFeeMin = parseFloat(defaultValue.cost.min);
  //                officialFeeMax = parseFloat(defaultValue.cost.max);
  //              } else if ((typeof defaultValue.cost === 'string' && defaultValue.cost.includes('-')) || (typeof defaultValue.cost === 'number' && defaultValue.cost.toString().includes('-'))) {
  //                const rangeMatch = defaultValue.cost.match(/^(\d+(?:\.\d+)?)\s*-\s*(\d+(?:\.\d+)?)$/);
  //                if (rangeMatch) {
  //                  officialFeeMin = parseFloat(rangeMatch[1]);
  //                  officialFeeMax = parseFloat(rangeMatch[2]);
  //                }
  //              } else {
  //                officialFeeMin = officialFeeMax = parseFloat(defaultValue.cost);
  //              }
  //            }

  //            if (defaultValue.professional) {
  //              if (typeof defaultValue.professional === 'object' && defaultValue.professional.min !== undefined && defaultValue.professional.max !== undefined) {
  //                professionalFeeMin = parseFloat(defaultValue.professional.min);
  //                professionalFeeMax = parseFloat(defaultValue.professional.max);
  //              } else if ((typeof defaultValue.professional === 'string' && defaultValue.professional.includes('-')) || (typeof defaultValue.professional === 'number' && defaultValue.professional.toString().includes('-'))) {
  //                const rangeMatch = defaultValue.professional.match(/^(\d+(?:\.\d+)?)\s*-\s*(\d+(?:\.\d+)?)$/);
  //                if (rangeMatch) {
  //                  professionalFeeMin = parseFloat(rangeMatch[1]);
  //                  professionalFeeMax = parseFloat(rangeMatch[2]);
  //                }
  //              } else {
  //                professionalFeeMin = professionalFeeMax = parseFloat(defaultValue.professional);
  //              }
  //            }
  //          }

  //          let val = {
  //            name: data.name,
  //            fromDate: data.result0,
  //            toDate: data.result1,
  //            isNotNormalProcess: data.type !== StepTypes.FIXED,
  //            costMin: officialFeeMin,
  //            costMax: officialFeeMax,
  //            professionalMin: professionalFeeMin,
  //            professionalMax: professionalFeeMax,
  //            type: data.type,
  //            selected: data.selected,
  //            stepDurationName: ""
  //          };

  //          if (data.duration.true.valueNames !== undefined && data.duration.true.selectedValueIndex !== undefined) {
  //            val.stepDurationName = data.duration.true.valueNames[data.duration.true.selectedValueIndex] || "";
  //          }

  //          steps.push(val);
  //        }
  //      }

  //      var timelineImage = await this.getTimelineImage();

  //      form['timelineImage'] = timelineImage;
  //      form['steps'] = steps;

  //      if (this.selectedReportId !== 0) {
  //        var attachmentFileName = `${this.selectedReportData.filename}.pdf`;
  //        console.log("Name " + attachmentFileName);
  //      } else {
  //        // Assuming form.filingDate is a string or Date object
  //        const filingDate: Date = new Date(form.filingDate); // Convert to a Date object if necessary
  //        const formattedDate: string = `${filingDate.getFullYear()} ${String(filingDate.getMonth() + 1).padStart(2, '0')} ${String(filingDate.getDate()).padStart(2, '0')}`;

  //        var attachmentFileName = `${country.name}-${protectionType.name}-${formattedDate}.pdf`;
  //        console.log("Name " + attachmentFileName);
  //      }

  //      var attachmentData = await this.rouseService.generatePDF(JSON.stringify(form));
  //      this.attachments.push({
  //        OriginalFileName: attachmentFileName,
  //        Base64Content: attachmentData
  //      });

  //      var sendToEmail = result.selectedOption === "1" ? this.userFullName : result.newEmail;

  //      var firstName = "";
  //      await this.userService.getUserProfile().then(user => {
  //        firstName = user.firstName;
  //      });

  //      await this.sendSelected(firstName, sendToEmail);

  //      //await this.rouseService.sendEmail(this.attachments, sendToEmail, firstName);
  //    }

  //  });


  //}

  toggleSelection(itemId: number) {
    if (this.selectedItems.has(itemId)) {
      this.selectedItems.delete(itemId);
    } else {
      this.selectedItems.add(itemId);
    }
  }

  async sendSelected() {
    const attachments: { OriginalFileName: string, Base64Content: string }[] = [];
    if (this.selectedItems.size === 0) {
      this.toastr.warning("No reports selected.");
      return;
    }
    const dialogRef = this.dialog.open(SendEmailDialog, {
      width: '450px',
      data: {
        dialogTitle: 'Send Report via email',
        selectedOption: '1',
        newEmail: '',
        myEmail: this.userFullName
      }
    });
    dialogRef.afterClosed().subscribe(async result => {
      if (result.selectedOption > 0) {
        this.toastr.info("Sending Email.");

        const selectedReports = this.calculatorData.filter(item => this.selectedItems.has(item.id));
        const firstName = await this.userService.getUserProfile().then(user => user.firstName);

        let index = 0;

        await this.updateAndGenerateTimelineImages();

        for (let item of selectedReports) {

          const formattedDate = this.datePipe.transform(item.filingDate, 'd MMMM y');

          const form = {
            countryId: item.countryId,
            matterCode: "-",
            clientRef: "-",
            protectionType: null,
            estimatedGrantDate: "",
            filingRoute: null,
            country: null,
            technicalField: null,
            data: item.data,
            filename: item.filename,
            filingDate: formattedDate,
            filingRouteId: item.filingRouteId,
            id: item.id,
            protectionTypeId: item.protectionTypeId,
            technicalFieldId: item.technicalFieldId,
            username: item.username
          };

          const country = this.countries.find(x => x.id == item.countryId);
          form.country = (typeof country !== 'undefined') ? country.name : '';

          const protectionType = this.protectionTypes.find(x => x.id == item.protectionTypeId);
          form.protectionType = (typeof protectionType !== 'undefined') ? protectionType.name : '';

          const filingRoute = this.filingRoutes.find(x => x.id == item.filingRouteId);
          form.filingRoute = (typeof filingRoute !== 'undefined') ? filingRoute.name : '';

          const technicalField = this.technicalFields.find(x => x.id == item.technicalFieldId);
          form.technicalField = (typeof technicalField !== 'undefined') ? technicalField.name : '';

          //Creating Variables
          let steps: any[] = [];
          //

          //Looping values from selected reports
          var parsedData = JSON.parse(item.data);

          let highestDate: Date | null = null;

          for (let data of parsedData) {

            if (data.selected == true) {

              const date0 = new Date(data.result0);
              const date1 = new Date(data.result1);

              const maxDate = date0 > date1 ? date0 : date1;

              if (!highestDate || maxDate > highestDate) {
                highestDate = maxDate;
              }
              var defaultValue = data.duration[data.selected].values[data.duration[data.selected].selectedValueIndex];

              // Handle official and professional fees
              let officialFeeMin = 0, officialFeeMax = 0;
              let professionalFeeMin = 0, professionalFeeMax = 0;

              let userInputs: any[] = [];

              if (data.cost) {
                if (typeof data.cost === 'object' && data.cost.min !== undefined && data.cost.max !== undefined) {
                  officialFeeMin = parseFloat(data.cost.min);
                  officialFeeMax = parseFloat(data.cost.max);
                } else if ((typeof data.cost === 'string' && data.cost.includes('-')) || (typeof data.cost === 'number' && data.cost.toString().includes('-'))) {
                  const rangeMatch = data.cost.match(/^(\d+(?:\.\d+)?)\s*-\s*(\d+(?:\.\d+)?)$/);
                  if (rangeMatch) {
                    officialFeeMin = parseFloat(rangeMatch[1]);
                    officialFeeMax = parseFloat(rangeMatch[2]);
                  }
                } else {
                  officialFeeMin = officialFeeMax = parseFloat(data.cost);
                }
              }

              if (data.professional) {
                if (typeof data.professional === 'object' && data.professional.min !== undefined && data.professional.max !== undefined) {
                  professionalFeeMin = parseFloat(data.professional.min);
                  professionalFeeMax = parseFloat(data.professional.max);
                } else if ((typeof data.professional === 'string' && data.professional.includes('-')) || (typeof data.professional === 'number' && data.professional.toString().includes('-'))) {
                  const rangeMatch = data.professional.match(/^(\d+(?:\.\d+)?)\s*-\s*(\d+(?:\.\d+)?)$/);
                  if (rangeMatch) {
                    professionalFeeMin = parseFloat(rangeMatch[1]);
                    professionalFeeMax = parseFloat(rangeMatch[2]);
                  }
                } else {
                  professionalFeeMin = professionalFeeMax = parseFloat(data.professional);
                }
              }

              // Adjust for TOGGLE_SELECTION or FIXED_SELECTION
              if (data.type == StepTypes.TOGGLE_SELECTION || data.type == StepTypes.FIXED_SELECTION) {
                if (defaultValue !== undefined) {
                  if (typeof defaultValue.cost === 'object' && defaultValue.cost.min !== undefined && defaultValue.cost.max !== undefined) {
                    officialFeeMin = parseFloat(defaultValue.cost.min);
                    officialFeeMax = parseFloat(defaultValue.cost.max);
                  } else if ((typeof defaultValue.cost === 'string' && defaultValue.cost.includes('-')) || (typeof defaultValue.cost === 'number' && defaultValue.cost.toString().includes('-'))) {
                    const rangeMatch = defaultValue.cost.match(/^(\d+(?:\.\d+)?)\s*-\s*(\d+(?:\.\d+)?)$/);
                    if (rangeMatch) {
                      officialFeeMin = parseFloat(rangeMatch[1]);
                      officialFeeMax = parseFloat(rangeMatch[2]);
                    }
                  } else {
                    officialFeeMin = officialFeeMax = parseFloat(defaultValue.cost);
                  }
                }

                if (defaultValue !== undefined) {
                  if (typeof defaultValue.professional === 'object' && defaultValue.professional.min !== undefined && defaultValue.professional.max !== undefined) {
                    professionalFeeMin = parseFloat(defaultValue.professional.min);
                    professionalFeeMax = parseFloat(defaultValue.professional.max);
                  } else if ((typeof defaultValue.professional === 'string' && defaultValue.professional.includes('-')) || (typeof defaultValue.professional === 'number' && defaultValue.professional.toString().includes('-'))) {
                    const rangeMatch = defaultValue.professional.match(/^(\d+(?:\.\d+)?)\s*-\s*(\d+(?:\.\d+)?)$/);
                    if (rangeMatch) {
                      professionalFeeMin = parseFloat(rangeMatch[1]);
                      professionalFeeMax = parseFloat(rangeMatch[2]);
                    }
                  } else {
                    professionalFeeMin = professionalFeeMax = parseFloat(defaultValue.professional);
                  }
                }
              }

              if (this.hasSelectedInputs(data)) {
                userInputs = data.userInput.values;
              }

              let val = {
                name: data.name,
                fromDate: data.result0,
                toDate: data.result1,
                isNotNormalProcess: data.type !== StepTypes.FIXED,
                costMin: officialFeeMin,
                costMax: officialFeeMax,
                professionalMin: professionalFeeMin,
                professionalMax: professionalFeeMax,
                type: data.type,
                selected: data.selected,
                stepDurationName: "",
                userInputs: userInputs
              };

              if (data.duration.true.valueNames !== undefined && data.duration.true.selectedValueIndex !== undefined) {
                val.stepDurationName = data.duration.true.valueNames[data.duration.true.selectedValueIndex] || "";
              }

              steps.push(val);
            }
          }

          if (highestDate) {
            const adjustedDate = new Date(highestDate);
            adjustedDate.setDate(adjustedDate.getDate() - 1);
            form.estimatedGrantDate = this.datePipe.transform(adjustedDate, 'y MMMM d');
          }

          const timelineImage = this.timelineImages[index];

          form['timelineImage'] = timelineImage;
          form['steps'] = steps;

          var attachmentFileName = `${item.filename}.pdf`;
          var attachmentData = await this.rouseService.generatePDF(JSON.stringify(form));
          attachments.push({
            OriginalFileName: attachmentFileName,
            Base64Content: attachmentData
          });

          index++;

        }


        var sendToEmail = result.selectedOption === "1" ? this.userFullName : result.newEmail;
        if (attachments.length > 0) {
          await this.rouseService.sendEmail(attachments, sendToEmail, firstName);
          this.toastr.success("Selected reports sent successfully.");
        } else {
          this.toastr.warning("No valid reports found to send.");
        }

      }
    });
  }

  //This sendSelected function sends the current report and selected saved report/s to an email 1
  //async sendSelected(firstName, sendToEmail) {

  //  if (this.selectedItems.size === 0) {
  //    this.toastr.warning("No reports selected.");
  //    return;
  //  }

  //  const selectedReports = this.calculatorData.filter(item => this.selectedItems.has(item.id));
  //  const firstName = await this.userService.getUserProfile().then(user => user.firstName);

  //  let index = 0;

  //  await this.updateAndGenerateTimelineImages();

  //  for (let item of selectedReports) {

  //    const formattedDate = this.datePipe.transform(item.filingDate, 'd MMMM y');

  //    const form = {
  //      countryId: item.countryId,
  //      matterCode: "-",
  //      clientRef: "-",
  //      protectionType: null,
  //      estimatedGrantDate: "",
  //      filingRoute: null,
  //      country: null,
  //      technicalField: null,
  //      data: item.data,
  //      filename: item.filename,
  //      filingDate: formattedDate,
  //      filingRouteId: item.filingRouteId,
  //      id: item.id,
  //      protectionTypeId: item.protectionTypeId,
  //      technicalFieldId: item.technicalFieldId,
  //      username: item.username
  //    };

  //    const country = this.countries.find(x => x.id == item.countryId);
  //    form.country = (typeof country !== 'undefined') ? country.name : '';

  //    const protectionType = this.protectionTypes.find(x => x.id == item.protectionTypeId);
  //    form.protectionType = (typeof protectionType !== 'undefined') ? protectionType.name : '';

  //    const filingRoute = this.filingRoutes.find(x => x.id == item.filingRouteId);
  //    form.filingRoute = (typeof filingRoute !== 'undefined') ? filingRoute.name : '';

  //    const technicalField = this.technicalFields.find(x => x.id == item.technicalFieldId);
  //    form.technicalField = (typeof technicalField !== 'undefined') ? technicalField.name : '';

  //    //Creating Variables
  //    let steps: any[] = [];

  //    //Looping values from selected reports
  //    var parsedData = JSON.parse(item.data);

  //    let highestDate: Date | null = null;

  //    for (let data of parsedData) {

  //      if (data.selected == true) {

  //        const date0 = new Date(data.result0);
  //        const date1 = new Date(data.result1);

  //        const maxDate = date0 > date1 ? date0 : date1;

  //        if (!highestDate || maxDate > highestDate) {
  //          highestDate = maxDate;
  //        }
  //        var defaultValue = data.duration[data.selected].values[data.duration[data.selected].selectedValueIndex];

  //        // Handle official and professional fees
  //        let officialFeeMin = 0, officialFeeMax = 0;
  //        let professionalFeeMin = 0, professionalFeeMax = 0;

  //        if (data.cost) {
  //          if (typeof data.cost === 'object' && data.cost.min !== undefined && data.cost.max !== undefined) {
  //            officialFeeMin = parseFloat(data.cost.min);
  //            officialFeeMax = parseFloat(data.cost.max);
  //          } else if ((typeof data.cost === 'string' && data.cost.includes('-')) || (typeof data.cost === 'number' && data.cost.toString().includes('-'))) {
  //            const rangeMatch = data.cost.match(/^(\d+(?:\.\d+)?)\s*-\s*(\d+(?:\.\d+)?)$/);
  //            if (rangeMatch) {
  //              officialFeeMin = parseFloat(rangeMatch[1]);
  //              officialFeeMax = parseFloat(rangeMatch[2]);
  //            }
  //          } else {
  //            officialFeeMin = officialFeeMax = parseFloat(data.cost);
  //          }
  //        }

  //        if (data.professional) {
  //          if (typeof data.professional === 'object' && data.professional.min !== undefined && data.professional.max !== undefined) {
  //            professionalFeeMin = parseFloat(data.professional.min);
  //            professionalFeeMax = parseFloat(data.professional.max);
  //          } else if ((typeof data.professional === 'string' && data.professional.includes('-')) || (typeof data.professional === 'number' && data.professional.toString().includes('-'))) {
  //            const rangeMatch = data.professional.match(/^(\d+(?:\.\d+)?)\s*-\s*(\d+(?:\.\d+)?)$/);
  //            if (rangeMatch) {
  //              professionalFeeMin = parseFloat(rangeMatch[1]);
  //              professionalFeeMax = parseFloat(rangeMatch[2]);
  //            }
  //          } else {
  //            professionalFeeMin = professionalFeeMax = parseFloat(data.professional);
  //          }
  //        }

  //        // Adjust for TOGGLE_SELECTION or FIXED_SELECTION
  //        if (data.type == StepTypes.TOGGLE_SELECTION || data.type == StepTypes.FIXED_SELECTION) {
  //          if (defaultValue.cost) {
  //            if (typeof defaultValue.cost === 'object' && defaultValue.cost.min !== undefined && defaultValue.cost.max !== undefined) {
  //              officialFeeMin = parseFloat(defaultValue.cost.min);
  //              officialFeeMax = parseFloat(defaultValue.cost.max);
  //            } else if ((typeof defaultValue.cost === 'string' && defaultValue.cost.includes('-')) || (typeof defaultValue.cost === 'number' && defaultValue.cost.toString().includes('-'))) {
  //              const rangeMatch = defaultValue.cost.match(/^(\d+(?:\.\d+)?)\s*-\s*(\d+(?:\.\d+)?)$/);
  //              if (rangeMatch) {
  //                officialFeeMin = parseFloat(rangeMatch[1]);
  //                officialFeeMax = parseFloat(rangeMatch[2]);
  //              }
  //            } else {
  //              officialFeeMin = officialFeeMax = parseFloat(defaultValue.cost);
  //            }
  //          }

  //          if (defaultValue.professional) {
  //            if (typeof defaultValue.professional === 'object' && defaultValue.professional.min !== undefined && defaultValue.professional.max !== undefined) {
  //              professionalFeeMin = parseFloat(defaultValue.professional.min);
  //              professionalFeeMax = parseFloat(defaultValue.professional.max);
  //            } else if ((typeof defaultValue.professional === 'string' && defaultValue.professional.includes('-')) || (typeof defaultValue.professional === 'number' && defaultValue.professional.toString().includes('-'))) {
  //              const rangeMatch = defaultValue.professional.match(/^(\d+(?:\.\d+)?)\s*-\s*(\d+(?:\.\d+)?)$/);
  //              if (rangeMatch) {
  //                professionalFeeMin = parseFloat(rangeMatch[1]);
  //                professionalFeeMax = parseFloat(rangeMatch[2]);
  //              }
  //            } else {
  //              professionalFeeMin = professionalFeeMax = parseFloat(defaultValue.professional);
  //            }
  //          }
  //        }

  //        let val = {
  //          name: data.name,
  //          fromDate: data.result0,
  //          toDate: data.result1,
  //          isNotNormalProcess: data.type !== StepTypes.FIXED,
  //          costMin: officialFeeMin,
  //          costMax: officialFeeMax,
  //          professionalMin: professionalFeeMin,
  //          professionalMax: professionalFeeMax,
  //          type: data.type,
  //          selected: data.selected,
  //          stepDurationName: ""
  //        };

  //        if (data.duration.true.valueNames !== undefined && data.duration.true.selectedValueIndex !== undefined) {
  //          val.stepDurationName = data.duration.true.valueNames[data.duration.true.selectedValueIndex] || "";
  //        }
  //        steps.push(val);
  //      }
  //    }

  //    if (highestDate) {
  //      const adjustedDate = new Date(highestDate);
  //      adjustedDate.setDate(adjustedDate.getDate() - 1);
  //      form.estimatedGrantDate = this.datePipe.transform(adjustedDate, 'y MMMM d');
  //    }

  //    const timelineImage = this.timelineImages[index];

  //    form['timelineImage'] = timelineImage;
  //    form['steps'] = steps;

  //    var attachmentFileName = `${item.filename}.pdf`;
  //    var attachmentData = await this.rouseService.generatePDF(JSON.stringify(form));
  //    this.attachments.push({
  //      OriginalFileName: attachmentFileName,
  //      Base64Content: attachmentData
  //    });

  //    index++;

  //  }

  //  if (this.attachments.length > 0) {
  //    await this.rouseService.sendEmail(this.attachments, sendToEmail, firstName);
  //    this.toastr.clear(this.toastRef.toastId);
  //    this.toastr.success("Email sent successfully!", "Success");
  //  } else {
  //    this.toastr.warning("No valid reports found to send.");
  //  }


  //}

  async updateAndGenerateTimelineImages() {
    this.timelineImages = [];
    this.isGeneratingCharts = true;

    const selectedReports = this.calculatorData.filter(item => this.selectedItems.has(item.id));

    if (selectedReports.length === 0) {
      console.error("No selected reports.");
      this.isGeneratingCharts = false;
      return;
    }

    const originalStepDurationData = [...(this.stepDurationData || [])];

    for (const item of selectedReports) {
      const parsedData = JSON.parse(item.data);
      if (Array.isArray(parsedData)) {
        this.stepDurationData = parsedData;
        this.calculateAllStepDurations();

        await this.getTimelineImage();
        await new Promise(resolve => setTimeout(resolve, 1000));
        const imageBase64 = await this.getTimelineImage();
        this.timelineImages.push(imageBase64);

        await new Promise(resolve => setTimeout(resolve, 2000));
      } else {
        console.error("Invalid data format for step durations.");
      }

    }

    this.stepDurationData = originalStepDurationData;
    this.calculateAllStepDurations();

    this.isGeneratingCharts = false;
  }

  getCountryName(countryId: number): string {
    const countries: Record<number, string> = {
      14: "Cambodia", 10: "China", 12: "India", 2: "Indonesia",
      15: "Korea", 7: "Malaysia", 4: "Philippines", 8: "Singapore",
      13: "Taiwan", 1: "Thailand", 3: "Vietnam"
    };
    return countries[countryId] || "Unknown Country";
  }

  getProtectionType(protectionTypeId: number): string {
    const protectionTypes: Record<number, string> = {
      16: "Patent", 33: "Utility Model", 36: "Industrial Design",
      35: "Design Patent", 18: "Design", 30: "Simple Patent",
      31: "Utility Innovation", 17: "Petty Patent", 32: "Utility Solution"
    };
    return protectionTypes[protectionTypeId] || "Unknown Protection Type";
  }

  getFilingRoute(filingRouteId: number): string {
    const filingRoutes: Record<number, string> = {
      10: "National", 11: "Conventional", 12: "PCT National Application",
      13: "Validation of Patent", 14: "Re-registration of Patent"
    };
    return filingRoutes[filingRouteId] || "Unknown Filing Route";
  }

  getTechnicalField(technicalFieldId: number): string {
    const technicalFields: Record<number, string> = {
      6: "Mechanical", 7: "Telecommunication",
      8: "Chemicals/Pharmaceuticals", 29: "All fields"
    };
    return technicalFields[technicalFieldId] || "Unknown Technical Field";
  }

  async onSave() {

    var filingDate = moment(this.form.controls['filingDate'].value).format('YYYY MM DD');
    const dialogRef = this.dialog.open(SaveReportDialog, {
      width: '450px',
      data: {
        dialogTitle: this.selectedReportId === 0 ? 'Save Report' : `Save changes to '${this.selectedReportData.filename}'`,
        dialogMode: this.selectedReportId === 0 ? 'add' : 'update',
        id: this.selectedReportId,
        selectedOption: '1',
        newFilename: this.selectedReportId === 0 ? '' : `${this.selectedReportData.filename}`,
        filename: this.selectedReportId === 0 ? `${this.countryName}-${this.protectionTypeName}-${filingDate}` : `${this.selectedReportData.filename}`
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        var country = this.form.controls['country'].value;
        var protectionType = this.form.controls['protectionType'].value;
        var filingRoute = this.form.controls['filingRoute'].value;
        var technicalField = this.form.controls['technicalField'].value;
        var filingDate = this.form.controls['filingDate'].value;
        var username = localStorage.getItem('email');

        if (this.countryId !== 0 && this.protectionTypeId !== 0 && this.filingRouteId !== 0 && this.technicalFieldId !== 0) {
          const calculatorModel = {
            filename: result.selectedOption == 2 ? result.newFilename : result.filename,
            countryId: this.countryId,
            protectionTypeId: Number.parseInt(protectionType),
            filingRouteId: Number.parseInt(filingRoute),
            technicalFieldId: Number.parseInt(technicalField),
            data: JSON.stringify(this.stepDurationData),
            userName: username,
            filingDate: filingDate
          };
          const ret = this.rouseService.postSavedReportData(calculatorModel).then(() => {
            this.rouseService.getSavedReportData(this.userFullName).then(result => {
              this.calculatorData = result;
              /*   This can be refactored*/
              this.checkifSavedIsEmpty();
            });
          });
        }
      }
    });

  }

  deleteReport(idx: number): void {
    this.openDeleteConfirmationDialog(idx);
  }

  openDeleteConfirmationDialog(deleteIndex: number): void {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '350px',
      data: "Are you sure you want to delete this record?"
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        var calculatorData = {
          id: deleteIndex,
          username: this.userFullName
        }
        this.rouseService.deleteSavedReportData(calculatorData).then((res) => {
          if (res === 'OK') {
            this.rouseService.getSavedReportData(this.userFullName).then(result => {
              this.calculatorData = result;
              /*   This can be refactored*/
              this.checkifSavedIsEmpty();
            });
          }

        });

      }
    });

  }
  toggle() {
    if (this.isExpanded) {
      this.isExpanded = false;
    }
    else {
      this.isExpanded = true;
    }
  }
  onReset() {
    sessionStorage.clear();
    location.reload();
  }



  async updateUserProfile(): Promise<void> {
    await this.userService.getUserProfile().then(user => {
      const dialogRef = this.dialog.open(UserProfileDialogComponent, {
        width: '550px',
        data: {
          dialogTitle: 'Update Profile',
          dialogMode: 'update',
          user: user
        }
      });

      dialogRef.afterClosed().subscribe(result => {

      });
    }
    );
  }

  async updateUserPassword(): Promise<void> {
    const dialogRef = this.dialog.open(UpdatePasswordDialogComponent, {
      width: '550px',
      data: {
        dialogTitle: 'Update Password',
        dialogMode: 'update',
      }
    });

    dialogRef.afterClosed().subscribe(result => {

    });
  }

  onToggleChange(event: MatSlideToggleChange) {
    this.showGrid = event.checked;
  }

  logout() {
    this.userService.logout().subscribe(res => {
      localStorage.removeItem('token');
      localStorage.removeItem('email');
      this.router.navigateByUrl('/login');
    });
  }
  reloadCurrentRoute() {
    sessionStorage.clear();
    location.href = "/";
  }

  timeline = {
    data: [],
    feeData: [],
    columnNames: [],
    options: {
      height: 45,
      timeline: {
        showRowLabels: true,
        groupByRowLabel: true,
        barLabelStyle: { fontSize: 11 },
      },

      hAxis: {
        format: 'MMM yyyy'
      },
      tooltip: {
        isHtml: true
      }
    }
  };

  timelineReports = {
    data: [],
    feeData: [],
    columnNames: [],
    options: {
      height: 45,
      timeline: {
        showRowLabels: true,
        groupByRowLabel: true,
        barLabelStyle: { fontSize: 11 },
      },

      hAxis: {
        format: 'MMM yyyy'
      },
      tooltip: {
        isHtml: true
      }
    }
  };
}
